<div class="inner-page-header py-5 text-white">
  <div class="container px-lg-5">
    <h1 class="display-5 fw-bold text-uppercase mb-2">Campus Overview</h1>
    <p class="lead mb-0 text-orange-light">A Sanctuary for Growth and Success</p>
  </div>
</div>

<div class="container px-lg-5 py-5">

  <!-- Quote -->
  <div class="text-center mb-4">
    <h4 class="fw-bold text-orange">"A Sanctuary for Growth and Success"</h4>
    <h5 class="fw-bold text-dark mt-2">"Education is not the filling of a pail, but the lighting of a fire." – William Butler Yeats'</h5>
  </div>

  <!-- Content -->
  <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success mb-5">

    <p class="text-muted mb-4" style="line-height: 1.8; text-align: justify;">
      This famous quote is still relevant in all areas of learning and Shah Satnam Ji Girls' College is dedicated to fostering an environment of academic excellence and holistic development. Our campus features a state-of-the-art double-storey building surrounded by <strong>lush green sitting areas</strong>, providing a serene and inspiring atmosphere for our students. The campus is fully equipped with <strong>Wi-Fi</strong>, ensuring seamless connectivity for academic and personal use.
    </p>

    <p class="text-muted mb-4" style="line-height: 1.8; text-align: justify;">
      Our facilities include <strong>a well-maintained canteen, a spacious auditorium, a seminar hall, and a hi-tech library</strong>, creating an ideal setting for learning and growth. We boast ten different laboratories, each designed to meet the needs of various scientific and technological disciplines.
    </p>

    <!-- Campus Gallery (inside content) -->
    <div class="row g-3 mb-4">
      <div class="col-6 col-md-4" *ngFor="let img of overviewImages">
        <div class="rounded-4 overflow-hidden shadow-sm border border-2 border-white">
          <img [src]="img" alt="Campus Facilities" class="img-fluid w-100" style="object-fit: cover; height: 220px;">
        </div>
      </div>
    </div>

    <p class="text-muted mb-4" style="line-height: 1.8; text-align: justify;">
      Our international-level <strong>sports facilities</strong> and <strong>smart classrooms</strong> further enhance the learning experience, while our dedicated co-curricular activity room supports a wide range of extracurricular pursuits.
    </p>

    <p class="text-muted mb-4" style="line-height: 1.8; text-align: justify;">
      We offer a diverse array of undergraduate and postgraduate courses, along with <strong>value-added and skill-enhancement courses</strong> tailored to equip our students with the necessary skills for their future careers. Our campus promotes daily yoga sessions and moral education, fostering physical well-being and ethical growth.
    </p>

    <p class="text-muted mb-4" style="line-height: 1.8; text-align: justify;">
      Shah Satnam Ji Girls College is proud to be a <strong>ragging-free campus</strong>, ensuring a safe and supportive environment for all students. We support various student organizations and initiatives, including <strong>NSS, NCC Air Wing, Red Cross, Red Ribbon Club, and the Women Cell</strong>, all contributing to a vibrant campus life. Our commitment to environmental sustainability is reflected in our green practices across the campus.
    </p>

    <p class="text-muted mb-4" style="line-height: 1.8; text-align: justify;">
      <strong>Transportation facilities</strong> are available for students' convenience, and our highly qualified faculty is dedicated to delivering quality education. We regularly organize workshops and seminars, providing students with opportunities to expand their knowledge and skills.
    </p>

    <p class="text-muted mb-4" style="line-height: 1.8; text-align: justify;">
      We emphasize the all-round development of our students, focusing on their <strong>safety, security, health, and wellness</strong>. Our holistic approach includes daily meditation sessions and activities like group clapping and laughing, aimed at enhancing mental health and fostering a positive community spirit.
    </p>

    <p class="text-muted mb-0" style="line-height: 1.8; text-align: justify;">
      At Shah Satnam Ji Girls College, we are <strong>committed to nurturing well-rounded individuals prepared to excel in their personal and professional lives</strong>.
    </p>

  </div>
</div>
